import React from 'react';
import { Link } from 'react-router-dom';

// Reason: navigation walks the dates index rather than calendar days, so an
// arrow never lands on a day the scheduler skipped. `dates` is newest-first.
export const resolveAdjacentDates = (dates, anchorDate) => {
  const available = (dates || []).map(d => d.briefing_date).filter(Boolean);
  const older = available.filter(d => d < anchorDate);
  const newer = available.filter(d => d > anchorDate);
  return {
    prevDate: older[0] ?? null,
    nextDate: newer[newer.length - 1] ?? null,
  };
};

export const formatArchiveDate = (isoDate) => {
  const [year, month, day] = String(isoDate || '').split('-').map(Number);
  if (!year || !month || !day) return isoDate || '';
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const ARROW_CLASS = 'btn-clay-icon inline-flex items-center';

const ArrowButton = ({ to, label, children }) => (
  to ? (
    <Link to={to} className={ARROW_CLASS} aria-label={label} title={label}>
      {children}
    </Link>
  ) : (
    <button type="button" disabled className={ARROW_CLASS} aria-label={label} title={label}>
      {children}
    </button>
  )
);

const BriefingDateNav = ({ dates, anchorDate, isArchive }) => {
  const { prevDate, nextDate } = resolveAdjacentDates(dates, anchorDate);
  const forwardTo = nextDate ? `/daily/${nextDate}` : (isArchive ? '/daily' : null);
  // Reason: on the live view the forward arrow is disabled, so naming it
  // "Latest briefing" announces a dead control named for the page you are
  // already on. Name it for what it is instead.
  const forwardLabel = nextDate
    ? 'Next briefing'
    : (isArchive ? 'Latest briefing' : 'No newer briefing');

  return (
    <div className="flex items-center gap-2">
      <ArrowButton to={prevDate ? `/daily/${prevDate}` : null} label="Previous briefing">
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </ArrowButton>
      {isArchive && (
        <span className="badge-fun-sky text-xs whitespace-nowrap" data-testid="archive-date">
          {formatArchiveDate(anchorDate)}
        </span>
      )}
      <ArrowButton to={forwardTo} label={forwardLabel}>
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </ArrowButton>
    </div>
  );
};

export default BriefingDateNav;
